import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';
const getToken = () => localStorage.getItem('notes_token') || '';
const getCurrentUser = () => localStorage.getItem('notes_user') || '';

const fetchWithAuth = async (url, options = {}) => {
  const token = getToken();
  const res = await fetch(url, {
    ...options,
    headers: { ...options.headers, 'x-token': token }
  });
  if (res.status === 401) {
    localStorage.removeItem('notes_token');
    localStorage.removeItem('notes_user');
    window.location.href = '/';
  }
  return res;
};

export default function ProjectDocHome() {
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [users, setUsers] = useState([]);
  
  // 创建表单
  const [formName, setFormName] = useState('');
  const [formManager, setFormManager] = useState('');
  const [formMembers, setFormMembers] = useState([]);

  useEffect(() => {
    loadProjects();
    loadUsers();
  }, []);

  const loadProjects = async () => {
    try {
      const res = await fetchWithAuth(`${API_URL}/api/doc-projects`);
      const data = await res.json();
      setProjects(data);
    } catch (e) {
      console.error('加载项目失败:', e);
    }
    setLoading(false);
  };

  const loadUsers = async () => {
    try {
      const res = await fetchWithAuth(`${API_URL}/api/users`);
      const data = await res.json();
      setUsers(data);
    } catch (e) {
      console.error('加载用户列表失败:', e);
    }
  };

  const handleCreate = async () => {
    if (!formName.trim()) return alert('请输入项目名称');
    if (!formManager) return alert('请选择项目经理');
    
    try {
      const res = await fetchWithAuth(`${API_URL}/api/doc-projects`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formName,
          manager: formManager,
          members: formMembers
        })
      });
      
      if (res.ok) {
        setShowCreate(false);
        setFormName('');
        setFormManager('');
        setFormMembers([]);
        loadProjects();
      } else {
        const data = await res.json();
        alert(data.error || '创建失败');
      }
    } catch (e) {
      alert('创建失败');
    }
  };

  const handleDelete = async (id, name) => {
    if (!confirm(`确定删除项目"${name}"？所有文件和文件夹都会被删除！`)) return;
    
    try {
      await fetchWithAuth(`${API_URL}/api/doc-projects/${id}`, { method: 'DELETE' });
      loadProjects();
    } catch (e) {
      alert('删除失败');
    }
  };

  const toggleMember = (username) => {
    setFormMembers(prev => 
      prev.includes(username) 
        ? prev.filter(m => m !== username)
        : [...prev, username]
    );
  };

  const getUserName = (username) => {
    const user = users.find(u => u.username === username);
    return user?.realname || username;
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>📁 项目文档</h2>
        <div style={{ display: 'flex', gap: 12 }}>
          <button 
            onClick={() => navigate('/work-logs/doc-overview')}
            style={{
              padding: '8px 16px', background: '#fff', border: '1px solid #d9d9d9',
              borderRadius: 6, cursor: 'pointer', fontSize: 14
            }}
          >
            📋 文档总览
          </button>
          <button 
            onClick={() => setShowCreate(true)}
            className="btn-primary"
          >
            + 新建项目
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loading">加载中...</div>
      ) : projects.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#999' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📁</div>
          <p>还没有项目文档</p>
          <button onClick={() => setShowCreate(true)} className="btn-primary" style={{ marginTop: 16 }}>
            创建第一个项目
          </button>
        </div>
      ) : (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: 20,
          marginTop: 24
        }}>
          {projects.map(project => (
            <div
              key={project.id}
              onClick={() => navigate(`/work-logs/doc-project/${project.id}`)}
              style={{
                padding: 24,
                background: '#fff',
                borderRadius: 12,
                border: '1px solid #e8e8e8',
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                position: 'relative'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.borderColor = '#1890ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                e.currentTarget.style.borderColor = '#e8e8e8';
              }}
            >
              <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 12, color: '#333' }}>
                📂 {project.name}
              </div>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 8 }}>
                👤 项目经理：{getUserName(project.manager)}
              </div>
              <div style={{ fontSize: 13, color: '#666', marginBottom: 12 }}>
                👥 成员：{project.members.length > 0 
                  ? project.members.map(m => getUserName(m)).join('、') 
                  : '无'}
              </div>
              <div style={{ fontSize: 12, color: '#999', display: 'flex', gap: 16 }}>
                <span>📂 {project.folders?.length || 0} 个文件夹</span>
                <span>📄 {project.folders?.reduce((sum, f) => sum + (f.files?.length || 0), 0) || 0} 个文件</span>
              </div>
              
              {/* 删除按钮 */}
              {(project.manager === currentUser || currentUser === 'jch') && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDelete(project.id, project.name);
                  }}
                  style={{
                    position: 'absolute', top: 12, right: 12,
                    padding: '4px 8px', background: '#fff1f0', border: '1px solid #ffa39e',
                    borderRadius: 4, cursor: 'pointer', fontSize: 12, color: '#f5222d'
                  }}
                >
                  删除
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {/* 创建项目弹窗 */}
      {showCreate && (
        <div className="modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <h3 className="modal-title">📁 新建项目</h3>
            
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 14, color: '#333' }}>
                项目名称 <span style={{ color: '#f5222d' }}>*</span>
              </label>
              <input
                type="text"
                value={formName}
                onChange={e => setFormName(e.target.value)}
                placeholder="请输入项目名称"
                style={{
                  width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9',
                  borderRadius: 6, fontSize: 14, boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 14, color: '#333' }}>
                项目经理 <span style={{ color: '#f5222d' }}>*</span>
              </label>
              <select
                value={formManager}
                onChange={e => setFormManager(e.target.value)}
                style={{
                  width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9',
                  borderRadius: 6, fontSize: 14, boxSizing: 'border-box'
                }}
              >
                <option value="">请选择项目经理</option>
                {users.map(u => (
                  <option key={u.username} value={u.username}>
                    {u.realname || u.username}（{u.username}）
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', marginBottom: 6, fontSize: 14, color: '#333' }}>
                项目成员（多选）
              </label>
              <div style={{
                border: '1px solid #d9d9d9', borderRadius: 6, padding: 12,
                maxHeight: 200, overflowY: 'auto'
              }}>
                {users.filter(u => u.username !== formManager).map(u => (
                  <label key={u.username} style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '6px 0', cursor: 'pointer'
                  }}>
                    <input
                      type="checkbox"
                      checked={formMembers.includes(u.username)}
                      onChange={() => toggleMember(u.username)}
                    />
                    <span>{u.realname || u.username}（{u.username}）</span>
                  </label>
                ))}
                {users.filter(u => u.username !== formManager).length === 0 && (
                  <div style={{ color: '#999', fontSize: 13 }}>请先选择项目经理</div>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button 
                onClick={() => setShowCreate(false)}
                style={{
                  padding: '8px 16px', background: '#fff', border: '1px solid #d9d9d9',
                  borderRadius: 6, cursor: 'pointer'
                }}
              >
                取消
              </button>
              <button onClick={handleCreate} className="btn-primary">
                创建
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
